// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__-hash-base-64-5-","DesktopOnly":"Toolbar__DesktopOnly__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Toolbar/Toolbar.scss
// module id = 114
// module chunks = 0